
export const createKeysMap = <T extends object>(): { [K in keyof T]: K } =>  {
    return new Proxy({} as any, {
        get: (_, prop) => {
            return prop;
        },
        
    });
}

export default { createKeysMap };